import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import {
  Box, Button,
  makeStyles, Tooltip, Typography, withStyles,
} from '@material-ui/core';
import CheckCircleOutlineRoundedIcon from '@material-ui/icons/CheckCircleOutlineRounded';
import EditIcon from '@material-ui/icons/Edit';
import parse from 'html-react-parser';
import PropTypes from 'prop-types';

import { AddNote } from '../../../services/courses';
import { setAnalytics } from '../../../utils';
import TransitionsModal from '../../General/TransitionsModal';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    margin: theme.spacing(2, 0),
  },
  containerHeader: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  containerHeaderMentor: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  containerHeaderMentorName: {
    fontFamily: 'Raleway',
    color: theme.palette.text.default,
    fontSize: '14px',
  },
  containerHeaderMentorSubname: {
    fontFamily: 'Raleway',
    color: theme.palette.text.default,
    fontSize: '10px',
  },
  containerHeaderTitle: {
    fontFamily: 'Raleway',
    color: theme.palette.text.default,
    fontSize: '18px',
  },
  containerCardText: {
    background: theme.palette.background.card,
    padding: theme.spacing(4, 3),
    borderRadius: '10px',
  },
  containerCardTextHeader: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: theme.spacing(2, 0),
  },
  containerCardTextIcon: {
    color: theme.palette.text.default,
    cursor: 'pointer',
    textAlign: 'center',
    margin: theme.spacing(0, 0, 0, 2),
  },
  containerCardTextTitle: {
    color: theme.palette.text.default,
    fontFamily: 'Raleway',
    fontSize: '16px',
  },
  containerCardTextContentText: {
    color: theme.palette.text.default,
    fontFamily: 'Raleway',
    fontSize: '14px',
    fontWeight: 400,
  },
  cardContainerButtonCancel: {
    background: theme.palette.background.grey,
    color: theme.palette.text.default,
    borderRadius: '5px',
    fontFamily: 'Raleway',
    fontSize: 12,
    '&:hover': {
      background: theme.palette.background.grey,
    },
    margin: theme.spacing(0, 1),
  },
  cardContainerButtonSubmit: {
    background: theme.palette.background.secondary,
    color: theme.palette.text.default,
    borderRadius: '5px',
    fontFamily: 'Raleway',
    fontSize: 12,
    paddingLeft: theme.spacing(1.5),
    paddingRight: theme.spacing(1.5),
    '&:hover': {
      background: theme.palette.background.secondary,
    },
    '&.$Mui-disabled': {
      backgroundColor: theme.palette.background.buttonDisabled,
      color: theme.palette.text.default,
    },
  },
  cardContainerButtons: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
}));

const LightTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.common.black,
    boxShadow: theme.shadows[1],
    fontSize: 11,
    fontFamily: 'Raleway',
  },
}))(Tooltip);
function Text({ textContent }) {
  const classes = useStyles();
  const location = useLocation();
  const { lessonId, topic, course } = location.state;

  const [highlightedText, setHighlightedText] = useState('');
  const [showButtons, setShowButtons] = useState(false);
  const [confirm, setConfirm] = useState(false);
  const { sub } = useSelector((store) => store.login);

  const highlight = () => {
    // setAnalytics('Lesson', 'Btn_Resaltado');
    setShowButtons(true);
    let text = '';
    const saveSelection = (event) => {
      event.preventDefault();
      if (window.getSelection) {
        text = window.getSelection().toString();
        setHighlightedText(text);
      } else if (document.selection && document.selection.type !== 'Control') {
        text = document.selection.createRange().text;
      }
      return text;
    };
    document.addEventListener('mouseup', saveSelection);
    return () => document.removeEventListener('mouseup', saveSelection);
  };
  const apiAddNote = () => {
    AddNote(highlightedText, sub, course, topic, lessonId);
    setAnalytics('Lesson', 'Btn_GuardarNotaSubrayada');
    setConfirm(true);
  };
  const handleHideButtons = () => {
    setShowButtons(false);
  };
  const handleCloseModalConfirm = () => {
    setConfirm(false);
    setShowButtons(false);
  };
  const styleIconModal = (e) => (<CheckCircleOutlineRoundedIcon className={e} />);
  return (
    <div>
      <Box className={classes.container}>
        <Box className={classes.containerCardText}>
          <Box className={classes.containerCardTextHeader}>
            <Typography className={classes.containerCardTextTitle} />
            <Box className={classes.cardContainerButtons}>
              { showButtons ? (
                <>
                  <Button
                    onClick={handleHideButtons}
                    className={classes.cardContainerButtonCancel}
                  >
                    Cancelar

                  </Button>
                  <Button className={classes.cardContainerButtonSubmit} onClick={apiAddNote} disabled={highlightedText === ''}>Guardar</Button>
                </>
              ) : null}
              <LightTooltip title="Resaltar y crear nota">
                <EditIcon className={classes.containerCardTextIcon} onClick={highlight} />
              </LightTooltip>
            </Box>
          </Box>
          <Box>
            <Typography className={classes.containerCardTextContentText}>
              {parse(textContent)}
            </Typography>
          </Box>
        </Box>
      </Box>
      <TransitionsModal open={confirm} handleClose={handleCloseModalConfirm} textBody="¡Tu nota se ha guardado con éxito!" icon={styleIconModal} />
    </div>
  );
}

export default Text;

Text.propTypes = {
  textContent: PropTypes.string.isRequired,
};
